
export default {
    OrderDetails: (data) => window.axios.post('view_order_details',data),
}